import { create } from 'zustand'
import { type State, type Action } from '#types/chat/index.ts'
import { globalChatReducer } from './globalChatReducer.ts'

export type GlobalChatStore = State & {
	dispatch: (action: Action) => void
}

export function createGlobalChatStore(initialState: State) {
	return create<State & { dispatch: (action: Action) => void }>(function (set) {
		return {
			...initialState,
			dispatch: function (action: Action) {
				set(function (state: State) {
					return globalChatReducer({ state, action })
				})
			},
		}
	})
}
